import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

import {
  hasActiveGeneration,
  invalidateGenerationReadModels,
  shouldReconcileGenerationReadModels,
  useGenerationLifecycleQuery,
} from '../../api/index.js';
import { useWorkspace } from '../../app/runtime.js';

export function GenerationLifecycleBoundary() {
  const { connection } = useWorkspace();
  const queryClient = useQueryClient();
  const lifecycle = useGenerationLifecycleQuery(connection.id);
  const previousActive = useRef(false);
  const previousUpdate = useRef(0);

  useEffect(() => {
    if (!lifecycle.dataUpdatedAt || lifecycle.dataUpdatedAt === previousUpdate.current) return;
    previousUpdate.current = lifecycle.dataUpdatedAt;

    const active = hasActiveGeneration(lifecycle.data);
    const reconcile = shouldReconcileGenerationReadModels({
      active,
      previouslyActive: previousActive.current,
    });
    previousActive.current = active;

    if (reconcile) void invalidateGenerationReadModels(queryClient);
  }, [lifecycle.data, lifecycle.dataUpdatedAt, queryClient]);

  return <Outlet />;
}
